import Cookies from './Cookies';

export default class PickUpButtons {
  constructor() {
    this.buttons = document.querySelectorAll('.js-pick-up-btn');
    this.cookies = new Cookies();
    this.last_page = this.cookies.getCookie('last_page_viewed');

    //reset last page
    this.cookies.setCookie('last_page_viewed', window.location.href, 60);

    if(this.last_page) {
      let url = new URL(this.last_page);
      let disallowed_urls = ['/', '/about-us/', '/thank-you-newsletter-sign-up/', '/privacy-policy/', '/legal-disclaimer/', '/ada-page/'];

      if(url && !disallowed_urls.includes(url.pathname)) {
        this.buttons.forEach((button) => {
          button.setAttribute('href', url.toString());
        });
      }
    }
  }
}
